import {
  ProductivityIntegrationStatusStep,
  ProductivityProvider,
} from "@app/common/types";

export const getStepDescription = (
  step: number,
  providerConfig: ProductivityProvider
) => {
  switch (step) {
    case ProductivityIntegrationStatusStep.INITIAL:
      return `Analyzing ${providerConfig.displayNameShort} for crucial insights...`;
    case ProductivityIntegrationStatusStep.INGESTION:
      return "Identifying topics, action items, and Q&A...";
    case ProductivityIntegrationStatusStep.REPORT_GENERATION:
      return "Creating your first Readout...";
    case ProductivityIntegrationStatusStep.COMPLETE:
      return `Your first ${providerConfig.displayNameShort} Readout is ready!`;
    default:
      return "";
  }
};
